
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[...path]",
      function () {
        return require("private-next-pages/article/[...path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/[...path]"])
      });
    }
  